import { ElementProperties, A, Div, VBoolean, if as _if } from 'alkali'
import Accordion, { AccordionOpts } from 'components/generic/Accordion'

export interface RowPanesOpts extends ElementProperties<AccordionOpts> {
	addable: VBoolean
}

export default class RowPanes extends Accordion {
	created(props: RowPanesOpts) {
		props.footer = _if(props.addable || false, [
			Div('.collapsible-section.add-row', [
				Div('.header', [
					A('Add row', {
						onclick: e => {
							this.addRow()
							return false
						}
					})
				])
			])
		])
		super.created(props)
	}

	protected addRow() {

	}
}